import { useCallback } from "react"
import { DashBoardCondition } from "features/dashBoard/types"
import { usePieGraphOption } from "./options"

type usePieGraphEventsProps<T> = {
	graphOption: ReturnType<typeof usePieGraphOption<T>>
	onChangeCondition: (
    axisKey?: string,
    changed?: DashBoardCondition,
    toggle?: boolean
  ) => void
}
export const usePieGraphEvents = <T,>({
	graphOption: {
		axisDef
	},
	onChangeCondition
}: usePieGraphEventsProps<T>) => {
  const onClickGraph = useCallback(
    (params: {
      data?: {
        code?: string
        name: string
      }
      event?: { event?: { ctrlKey?: boolean }}
    }) => {
      if (!axisDef?.key) return
      const data = params?.data
      if (!data?.code) return
      onChangeCondition(
        axisDef.key,
        { code: [data.code], label: data.name },
        params?.event?.event?.ctrlKey ? true : false
      )
    },
    [axisDef, onChangeCondition]
  )
	return {
		click: onClickGraph
	}
}